<div class="analysis-layout">
  <ng-content select="[layoutTop]"></ng-content>
  <div class="analysis-layout__body">
    <ng-content></ng-content>
  </div>
</div>
